import { errorExtension } from './error';
import { headerExtension } from './header';
import { successExtension } from './success';
import { TableExtension } from './table';
import { warningExtension } from './warning';

export const markdownExtensions = [
  headerExtension,
  errorExtension,
  successExtension,
  new TableExtension(),
  warningExtension,
];
